export function getDeviceId() {
  const key = "y_device_id";
  let id = localStorage.getItem(key);
  if (!id) {
    id =
      (typeof crypto !== "undefined" && crypto.randomUUID)
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(key, id);
  }
  return id;
}
